<div class="calendario-container">
  <div class="calendario-header">
    <button (click)="mesAnterior()">◀</button>
    <h1>{{ mesActivo() }}</h1>
    <button (click)="mesSiguiente()">▶</button>
  </div>
  <div class="calendario">
    <span class="dia-semana" *ngFor="let d of DIAS_SEMANA">{{ d }}</span>
    <div
      *ngFor="let dia of diasDetallados()"
      [class.dia--disabled]="!dia.esMes"
      [class.dia--todia]="dia.esHoy"
      class="dia"
    >
      {{ dia.fecha | date: "d" }}
      <div *ngIf="refAnotaciones() as refAnotaciones" class="anotaciones">
        <ng-container
          *ngTemplateOutlet="
            refAnotaciones;
            context: { $implicit: dia.anotaciones }
          "
        ></ng-container>
      </div>
    </div>
  </div>
</div>
